import { useEffect } from 'react'
import { useAuth } from '@clerk/clerk-react'
import { api } from '@/lib/api'
import { toast } from 'sonner'

export function AuthSetup({ children }: { children: React.ReactNode }) {
  const { getToken, signOut } = useAuth()

  useEffect(() => {
    // Set up the auth token getter for the API client
    api.setAuthTokenGetter(async () => {
      try {
        return await getToken()
      } catch (error) {
        console.error('Failed to get auth token:', error)
        toast.error('获取认证令牌失败，请重新登录')
        return null
      }
    })

    // Set up auth error handler for 401 responses
    api.setAuthErrorHandler(async () => {
      toast.error('登录已过期，请重新登录')
      // Sign out and redirect to sign-in page
      await signOut()
      window.location.href = '/sign-in'
    })
  }, [getToken, signOut])

  return <>{children}</>
}
